import { Suspense, useEffect } from 'react'
import { Outlet } from 'react-router-dom'
import { I18nProvider } from '../_metronic/i18n/i18nProvider'
import { LayoutProvider, LayoutSplashScreen } from '../_metronic/layout/core'
import { MasterInit } from '../_metronic/layout/MasterInit'
import { AuthInit } from './modules/auth'

// import { getToken } from 'firebase/messaging'
// import { messaging } from '../firebase'
// import { useAuth } from '../app/modules/auth';
// import { setFCMToken } from './modules/apps/user-management/users-list/core/_requests'




const App = () => {
  // const { currentUser } = useAuth()

  // async function requestPermission() {
  //   const permission = await Notification.requestPermission()

  //   if (permission === 'granted') {

  //     const serviceWorkerRegistration = await navigator.serviceWorker.register(`${process.env.REACT_APP_HOME_PAGE}firebase-messaging-sw.js`);

  //     // serviceWorkerRegistration.showNotification("Vibration Sample", {
  //     //   body: "Buzz! Buzz!",
  //     //   icon: "../images/touch/chrome-touch-icon-192x192.png",
  //     //   vibrate: [200, 100, 200, 100, 200, 100, 200],
  //     //   tag: "vibration-sample",
  //     // });
  //     //generate token
  //     const token = await getToken(messaging, {
  //       vapidKey: "BDQTo_M09wVhr1YaZsU-UZVUVOtkEvupOZwlVIDoz2dyENE8C16GKs_q_TMq1kgxLcGOMwWx-8lcSxUrgJVmpyg",
  //       serviceWorkerRegistration
  //     })
  //       .then((currentToken) => {
  //         if (currentToken) {
  //           // Send the token to your server and update the UI if necessary

  //           setFCMToken(currentToken, currentUser?.user?.id as number).then((result) => {
  //             console.log("token =", currentToken)
  //           });
  //           // navigator.sendBeacon(
  //           //   `${process.env.REACT_APP_THEME_API_URL}/setToken?fcm_token=${currentToken}&user_id=${currentUser?.user?.id}`
  //           // ); //ping the server with the new device token
  //         } else {
  //           // Show permission request UI
  //           console.log("No registration token available. Request permission to generate one.");
  //           requestPermission();
  //           // ...
  //         }
  //       })
  //       .catch((err) => {
  //         console.log("An error occurred while retrieving token. ", err);
  //         // ...
  //       });





  //   } else if (permission === 'denied') {
  //     alert('You Denied for the notification');
  //   }
  // }

  // useEffect(() => {
  //   //Req user for notification permission
  //   if (currentUser?.user?.id) {
  //     requestPermission()

  //   }

  // }, [currentUser?.user?.id])
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <I18nProvider>
        <LayoutProvider>
          <AuthInit>
            <Outlet />
            <MasterInit />
          </AuthInit>
        </LayoutProvider>
      </I18nProvider>
    </Suspense>
  )
}

export { App }
